var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ErrorText } from 'components/Forms/ErrorText';
import { inputName } from 'components/Forms/inputName';
import { Label } from 'components/Forms/Label';
import { RawInput } from 'components/Forms/RawInput';
import { useFocusOnError } from 'hooks/useFocusOnError';
import * as React from 'react';
import { uniqueId } from 'utils/uniqueId';
import { ErrorMessage } from 'formik';
/*
For simple fields use as FieldInput<keyof SomeObject> name='fieldName'
For array fields use as FieldInput<keyof SomeObject> name='fieldName' index={indexValue}
For nested fields use as FieldInput<keyof NestedObject> name='nestedField' prefix='fieldOfParent.'

Note string `fieldOfParent.` wont be type checked.

 */
function FieldInputRaw(_a) {
    var { title, name, required, fast, type, description, className, inputClass, wrapperClass, index, filter, prefix, sensitive, stickyError } = _a, otherProps = __rest(_a, ["title", "name", "required", "fast", "type", "description", "className", "inputClass", "wrapperClass", "index", "filter", "prefix", "sensitive", "stickyError"]);
    const strName = inputName(name, prefix, index);
    const [[inputId]] = React.useState(() => uniqueId(strName));
    const fieldRef = React.useRef(null);
    useFocusOnError({ fieldRef, name });
    return (React.createElement("div", { className: className || 'sign-block' },
        !!title && React.createElement(Label, { title: title, forHtml: inputId, required: required }),
        React.createElement("div", { className: wrapperClass || 'controls' },
            React.createElement(RawInput, Object.assign({ name: name, fast: fast, prefix: prefix, index: index, className: inputClass, filter: filter, type: type, required: required, inputId: inputId, sensitive: sensitive, forwardedRef: fieldRef }, otherProps))),
        !!description && React.createElement("div", { className: "small-txt" }, description),
        React.createElement(ErrorMessage, { name: strName }, (msg) => (React.createElement(ErrorText, { error: msg, className: stickyError ? 'sticky-error' : '' })))));
}
export const FieldInput = React.memo(FieldInputRaw);
